export default "/images/pdf.svg?a8081e7edf1cf3dfb6266c26abfdbc2e";